import type { dateDiff } from '../../../../common/utils';

const UNIT_LABELS = ['년', '개월', '일', '시간', '분'] as const;
type ToRelativeDurationString = (relativeDuration: ReturnType<typeof dateDiff>) => string;
export const toRelativeTimeString: ToRelativeDurationString = ({
  year,
  month,
  day,
  hour,
  minute,
}) => {
  const units = [year, month, day, hour, minute].map((value, index) =>
    value > 0 ? `${value}${UNIT_LABELS[index]}` : '',
  );

  return units.filter(Boolean).join(' ');
};
